"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var OvenMit = function OvenMit(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.333,15.916l-8.748,4.17.595,1.25a1.385,1.385,0,0,0,1.846.654l6.249-2.979a1.384,1.384,0,0,0,.654-1.845Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.051,5.2A1.731,1.731,0,0,0,12.026,6.58L11.7,8.292,10.09,4.915A5.031,5.031,0,0,0,3.75,2.272,4.846,4.846,0,0,0,1.223,8.837L6.585,20.086l8.748-4.17-.922-1.935a1.391,1.391,0,0,1-.11-.855l1.125-5.9A1.731,1.731,0,0,0,14.051,5.2Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.653,19.784l.713,1.5a1.385,1.385,0,0,0,1.846.654l6.249-2.979a1.384,1.384,0,0,0,.654-1.845l-.6-1.25",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.109,17.49l3.41-1.626L21.6,13.929a1.391,1.391,0,0,1-.11-.855l1.125-5.9a1.731,1.731,0,1,0-3.4-.649L18.886,8.24l-1.61-3.377a5.1,5.1,0,0,0-5.624-2.872",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }));
};
OvenMit.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
OvenMit.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = OvenMit;